import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/auth.js';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Menu from '../../components/Menu/menu';
import ProcessandoModal from '../../components/Processamento/processamento';

import ModalGrafico from './Componentes/ModalGrafico.js';
import PainelFiltros from './Componentes/PainelFiltros';
//import CartoesKPI from './Componentes/CartoesKPI';

import GraficoSumOfLitros from  './Componentes/GraficoSumOfLitros.js';
import GraficoQtdComDiaEquipamento from './Componentes/GraficoQtdComDiaEquipamento.js';  
import GraficoVolDiaMes from './Componentes/GraficoVolDiaMes.js';
import GraficoQtdComTipo from './Componentes/GraficoQtdComTipo.js';
import GraficoVolComTipo from './Componentes/GraficoVolComTipo.js';
import GraficoNasInicialFinal from './Componentes/GraficoNasInicialFinal';
import TabelaDesvios from './Componentes/TabelaDesvios.js';
import GraficoQtdDesvio from './Componentes/GraficoQtdDesvio';

import { listarEquipamentos, listarCompartimentos, listarFluidos } from '../../services/apigateway';
import { dashboard, listarAnos, listarNas } from '../../services/apidashboard.js';
import { getPeriodoAtualFormatado, dataHoraFormatoMySQL } from '../../services/datautils';

export default function DashboardPBI() {
  const { clienteId, ligaMenu } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [graficoSelecionado, setGraficoSelecionado] = useState(null);

  const abrirModal = (grafico) => {
    setGraficoSelecionado(grafico);
    setModalOpen(true);
  };

  const [equipamentos, setEquipamentos] = useState([]);
  const [compartimentos, setCompartimentos] = useState([]);
  const [fluidos, setFluidos] = useState([]);
  const [nas, setNas] = useState([]);
  const [anos, setAnos] = useState([]);

  const periodo = getPeriodoAtualFormatado();

  const [filtros, setFiltros] = useState({
    clienteId: clienteId,
    equipamentoId: '',
    compartimentoId: '',
    fluido: '',
    nas: '',
    ano: '',
    mes: '',
    inicio: periodo.dataInicio,
    fim: periodo.dataFim,
  });

  const [dashboardData, setDashboardData] = useState({
    graficoSumOfLitros: [],
    graficoQtdComDiaEquipamento: [],
    graficoVolDiaMes: [],
    graficoQtdComTipo: [],
    graficoVolComTipo: [],
    graficoNASInicialFinal: [],
    tabelaDesvios: [],
    graficoQtdDesvio: []
  });

  const handleFilterChange = (key, value) => {
    setLoading(true);
    let valorFinal = value;
    if (key === 'inicio' || key === 'fim') {
      valorFinal = dataHoraFormatoMySQL(value);
      // console.log('Data: ', valorFinal);
    }
    setFiltros(prev => ({ ...prev, [key]: valorFinal }));
    
    // Se mudou o equipamento, busca compartimentos
    if (key === 'equipamentoId') {
      loadCompartimentos(value);
      setFiltros(prev => ({ ...prev, compartimentoId: '' }));
    }
    
    setLoading(false);
  };

  useEffect(() => {
    if (equipamentos.length === 0) {
      loadEquipamentos();
    }
    if (fluidos.length === 0) {
      loadFluidos();
    }
    if (nas.length === 0) {
      loadNas();
    }
    if (anos.length === 0) {
      loadAnos();
    }
    loadDashboard();
    // eslint-disable-next-line
  }, [filtros]);

  async function loadEquipamentos() {
    try {
      if (!clienteId) return;
      const response = await listarEquipamentos(clienteId);
      setEquipamentos(response);
    } catch(err) {
      console.log(err);
    }
  }

  async function loadCompartimentos(equipamentoId) {
    try {
      if (!equipamentoId) {
        setCompartimentos([]);
        return;
      }
      const response = await listarCompartimentos(clienteId, equipamentoId);
      setCompartimentos(response);
    } catch(err) {
      console.log(err);
    }
  }

  async function loadFluidos() {
    try {
      if (!clienteId) return;
      const response = await listarFluidos(clienteId);
      setFluidos(response);
    } catch(err) {
      console.log(err);
    }
  }

  async function loadNas() {
    try {
      if (!clienteId) return;
      const response = await listarNas(clienteId);
      setNas(response);
      // console.log('Response NAS: ', response);
    } catch(err) {
      console.log(err);
    }
  }

  async function loadAnos() {
    try {
      if (!clienteId) return;
      const response = await listarAnos(clienteId);
      setAnos(response);
      // console.log('Response Anos: ', response);
    } catch(err) {
      console.log(err);
    }
  }

  async function loadDashboard() {
    // setLoading(true);
    try {
      const response = await dashboard(filtros);

      setDashboardData({
        graficoSumOfLitros: response.graficoSumOfLitros,
        graficoQtdComDiaEquipamento: response.graficoQtdComDiaEquipamento,
        graficoVolDiaMes: response.graficoVolDiaMes,
        graficoQtdComTipo: response.graficoQtdComTipo,
        graficoVolComTipo: response.graficoVolComTipo,
        graficoNASInicialFinal: response.graficoNASInicialFinal,
        tabelaDesvios: response.tabelaDesvios,
        graficoQtdDesvio: response.graficoQtdDesvio
      });
    
    } catch(err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  if (!clienteId) return <div />;

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Dashboard'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={loading} message="Aguarde, buscando dados..." />
        </section>
      </main>
    </div>
    )
  }
  
  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />
      <main>
        <Titulo tela={'Dashboard Analytics'} destination={''} />
        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <section className='p-4 h-full relative'>
            <div className="min-h-screen bg-gray-100 p-6 border border-gray-300 rounded-md">
              <PainelFiltros 
                filtros={filtros} 
                onChange={handleFilterChange} 
                equipamentos={equipamentos}
                compartimentos={compartimentos}
                fluidos={fluidos}
                nas={nas}
                anos={anos}
              />
            </div>
            <div className="">
              <div className="grid grid-cols-1 gap-6 bg-white">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="">
                    <p></p>
                  </div>

                  {/* Sum of Litros */}
                  <div className="border border-gray-300 rounded-md p-2 relative">
                    {/* <button
                      onClick={() => abrirModal('sumLitros')}
                      className="absolute top-2 right-2 text-xs bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                    >
                      Expandir
                    </button> */}
                    <GraficoSumOfLitros dados={dashboardData.graficoSumOfLitros} />
                  </div>

                  <div className="">
                    <p></p>
                  </div>
                </div>
                {/* Quantidade Compartimentos por Equipamentos */}
                <div className="lg:col-span-2 border border-gray-300 rounded-md p-2 relative">
                  {/* <button
                    onClick={() => abrirModal('QtdComEqp')}
                    className="absolute top-2 right-2 text-xs bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  >
                    Expandir
                  </button>                   */}
                  <GraficoQtdComDiaEquipamento dados={dashboardData.graficoQtdComDiaEquipamento} />
                </div>

                {/* Soma de Litros */}
                <div className="lg:col-span-2 border border-gray-300 rounded-md p-2 relative">
                  {/* <button
                    onClick={() => abrirModal('volDiaMes')}
                    className="absolute top-2 right-2 text-xs bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  >
                    Expandir
                  </button> */}
                  <GraficoVolDiaMes dados={dashboardData.graficoVolDiaMes} isFullscreen={false}/>
                </div>

                {/* Quantidade por Compartimento + Volume por Compartimento + NAS */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="border border-gray-300 rounded-md p-2 relative">
                    {/* <button
                      onClick={() => abrirModal('qtd')}
                      className="absolute top-2 right-2 text-xs bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                    >
                      Expandir
                    </button> */}
                    <GraficoQtdComTipo dados={dashboardData.graficoQtdComTipo} />
                  </div>
                  <div className="border border-gray-300 rounded-md p-2 relative">
                    {/* <button
                      onClick={() => abrirModal('vol')}
                      className="absolute top-2 right-2 text-xs bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                    >
                      Expandir
                    </button> */}
                    <GraficoVolComTipo dados={dashboardData.graficoVolComTipo} />
                  </div>
                  <div className="border border-gray-300 rounded-md p-2 relative">
                    {/* <button
                      onClick={() => abrirModal('nas')}
                      className="absolute top-2 right-2 text-xs bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                    >
                      Expandir
                    </button> */}
                    <GraficoNasInicialFinal dados={dashboardData.graficoNASInicialFinal} />
                  </div>
                </div>

                {/* Relação de Desvios */}
                <div className="lg:col-span-2 border border-gray-300 rounded-md p-2 relative">
                  {/* <button
                    onClick={() => abrirModal('desvios')}
                    className="absolute top-2 right-2 text-xs bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  >
                    Expandir
                  </button> */}
                  <TabelaDesvios dados={dashboardData.tabelaDesvios} />
                </div>

                {/* Quantidade por Desvio */}
                <div className="lg:col-span-2 border border-gray-300 rounded-md p-2 relative">
                  {/* <button
                    onClick={() => abrirModal('desvio')}
                    className="absolute top-2 right-2 text-xs bg-gray-200 px-2 py-1 rounded hover:bg-gray-300"
                  >
                    Expandir
                  </button> */}
                  <GraficoQtdDesvio dados={dashboardData.graficoQtdDesvio} />
                </div>

                {/* Modal */}
                <ModalGrafico isOpen={modalOpen} onClose={() => setModalOpen(false)}>
                  {graficoSelecionado === 'sumLitros' && (
                    <GraficoSumOfLitros dados={dashboardData.graficoSumOfLitros} />
                  )}
                  {graficoSelecionado === 'QtdComEqp' && (
                    <GraficoQtdComDiaEquipamento dados={dashboardData.graficoQtdComDiaEquipamento} />
                  )}
                  {graficoSelecionado === 'volDiaMes' && (
                    <GraficoVolDiaMes dados={dashboardData.graficoVolDiaMes} isFullscreen={true} />
                  )}
                  {graficoSelecionado === 'qtd' && (
                    <GraficoQtdComTipo dados={dashboardData.graficoQtdComTipo} />
                  )}
                  {graficoSelecionado === 'vol' && (
                    <GraficoVolComTipo dados={dashboardData.graficoVolComTipo} />
                  )}
                  {graficoSelecionado === 'nas' && (
                    <GraficoNasInicialFinal dados={dashboardData.graficoNASInicialFinal} />
                  )}
                  {graficoSelecionado === 'desvios' && (
                    <TabelaDesvios dados={dashboardData.tabelaDesvios} />
                  )}
                  {graficoSelecionado === 'desvio' && (
                    <GraficoQtdDesvio dados={dashboardData.graficoQtdDesvio} />
                  )}
                </ModalGrafico>    
              </div>
            </div>
          </section>
        </section>
      </main>

    </div>
  );
}